import requestHzero from './requestHzero';
// import requestHzero from 'utils/request';
import { notification } from 'choerodon-ui';
import intl from 'utils/intl';
// import formatterCollections from 'utils/intl/formatterCollections';

/**
 *
 * @param {*} url: string
 * @param {*} options: request Options
 * @param {*} config: {
 *  noError: 出错的时候 不需要弹窗提醒
 *  noSuccess: 成功的时候 不需要弹窗提醒
 *  errMessage: 出错的时候 提醒标题
 *  successMessage: 成功的时候 提醒标题
 *  successDescription: 成功的时候 具体提醒说明
 *  ...
 * }
 * @returns Promise
 *
 * requestGet, requestPost 等等参数同 request
 */
const defaultCatch = (...rest) => {
  console.log('beforeCatch err', rest);
};

const request = (url, options = {}, config) => {
  return new Promise((resolve, reject) => {
    const {
      noError,
      noSuccess,
      errMessage = intl.get('hzero.common.notification.failed').d('操作失败'),
      successMessage = intl.get('cbms.common.view.success').d('成功'),
      successDescription = intl.get('hzero.common.notification.success').d('操作成功'),
      beforeCatch,
    } = config;
    requestHzero(
      url,
      {
        method: 'GET',
        // query: {
        //   size: 9,
        // },
        ...options,
      },
      {
        beforeCatch: beforeCatch || (noError ? defaultCatch : undefined),
        noError,
      }
    )
      .then((res) => {
        console.log('requestHzero', res);
        if (res?.failed === true) {
          if (!noError) {
            // 出错 不需要弹窗提示
            notification.error({
              message: errMessage,
              description: res?.message || res?.requestMessage,
            });
          }
          return reject(res);
        } else {
          if (noSuccess) {
            // noSuccess
          } else {
            // 成功 不需要弹窗提示
            notification.success({
              message: successMessage,
              description: successDescription,
            });
          }
          return resolve(res);
        }
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
const requestGet = (url, options = {}, config) => {
  return request(
    url,
    {
      method: 'GET',
      ...options,
    },
    {
      noSuccess: true,
      ...config,
    }
  );
};

const requestPost = (url, options = {}, config) => {
  return request(
    url,
    {
      method: 'POST',
      ...options,
    },
    {
      ...config,
    }
  );
};
const requestPut = (url, options = {}, config) => {
  return request(
    url,
    {
      method: 'PUT',
      ...options,
    },
    {
      ...config,
    }
  );
};
const requestDelete = (url, options = {}, config) => {
  return request(
    url,
    {
      method: 'DELETE',
      ...options,
    },
    {
      ...config,
    }
  );
};
export { requestGet, requestPost, requestPut, requestDelete };
